import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonFiles from "src/components/UI/buttons/ButtonFile";
import DropZone from "src/components/UI/Dropzone";
import ProgressbarTitle from "src/components/UI/ProgressbarTitle";
import { setCSV, setFiles, setNameFileCSV  } from "../../../../store/stockpile/CreateAssetsCsvForm";
import { RootState } from "src/store/store";
import { toBase64 } from "src/util/converToBase64";
import InputFloatingLabel from '../../../UI/forms/InputFloatingLabel';
import TextArea from '../../../UI/forms/TextArea';

const UploadAssets: React.FC = () => {

  const dispatch = useDispatch()
  const percentUpload = useSelector((state: RootState) => state.stockpileSlice.PercentUploadCSV);
  const files = useSelector((state: RootState) => state.CreateAssetsCsvForm.files);

 // const [files, setFiles] = useState([]);
  const [errorcsv, setErrorCsv] = useState<any>('')

  console.log('este es el file :' , files);
  
  const handleCSV = async (dataFile: any) => {
    dispatch(setFiles(dataFile))

    const file = dataFile[0]
    const value = await toBase64(file)
    dispatch(setNameFileCSV(dataFile[0].path))
    dispatch(setCSV(value))
  }

  return (
    <div className="container-fluid px-3 mt-3 ">
                   <h5
                className='text-primary col-auto mt-2' >Upload Assets</h5>
      <div className="row mt-5 pt-5">
        <div className="col-lg-5 col-md-12 col-sm-12 col-12">
          <DropZone
            setFile={handleCSV}
            files={files}
            errors={errorcsv}
            file={true}
          />
        </div>
        <div className="col-4 align-content-start mt-3 " style={{ marginRight: '26%', marginLeft: '1.5%', float: 'left' }}>
          <p className="poppinsText text-primary" style={{ marginLeft: '-3%', fontSize: '12px' }}>
            {percentUpload * 100}% UPLOAD COMPLETE</p>
          <ProgressbarTitle value={percentUpload} file width={'400px'} />
        </div>
      </div>
    </div>
  );
};

export default UploadAssets;
